<template>
  <div class="container">
    <div class="inner cover">          
        <font-awesome-icon icon="circle-check" class="fa-4x text-success" v-if="showSuccessIcon"/> 
        <font-awesome-icon icon="circle-xmark" class="fa-4x text-danger" v-if="!showSuccessIcon"/> 
            
        <div class="container">
            <div class="row p-4">
              <div class="col-sm-4">
            </div>
            <div class="col-sm-4">  
                <p class="fw-bold">{{message}}</p>
                <button class="btn btn-md btn-dark" @click="ok">OK</button>
            </div>
            <div class="col-sm-4">
            </div>
        </div>
    </div>
  </div>          
</div>

</template>
<script>
import AccountService from "../services/account.service";


export default {
  name: 'Message',

  props: ["response"],

  data() {
    return {
      message: this.response.message,
      showSuccessIcon: this.response.is_success
    };
  },

  methods: {
   
    deleteAccount() {
      AccountService.delete().then(
        (response) => {
          this.deleteMessage = "";
        },
        (error) => {
          this.deleteMessage =
            (error.response &&
              error.response &&
              error.response.data.detail) ||
            error.response.data.detail ||
            error.response.data.detail.toString();
        }
      );
    },

    ok() {
      if (localStorage.getItem("token") != null)
        localStorage.removeItem("token")

      this.$router.go('/');
    }
  }
}
</script>
<style scoped>
button { margin: 5px 5px 5px 5px } 
.btn-danger, .btn-danger:hover, .btn-danger:active, .btn-danger:visited {
    background-color:#EC1C24 !important;
}
</style>
